export const USER_PERMISSIONS = ['audits', 'users', 'checkins'] as const

export const USER_PERMISSION_KEYS: string[] = [...USER_PERMISSIONS]
